module.exports = __webpack_public_path__ + "img/play-circle-line.5d6bf916.png";